module.exports = __webpack_public_path__ + "static/media/Close_hover.cae92a77.svg";